const SUBJECT_DOCUMENT_FIELDS = [
  "atpDocument",
  "capsDocument",
  "poaDocument",
  "policyDocument",
  "sipDocument"
];

const normalizeDocument = (document) => {
  if (!document) {
    return null;
  }

  return {
    name: document.name || "",
    path: document.path || "",
    type: document.type || "",
    uploadedAt: document.uploadedAt || null,
    url: document.url || ""
  };
};

export const normalizeSubjectDocument = (subjectData = {}, options = {}) => {
  const {
    userId = subjectData.userId || "",
    createdBy = subjectData.createdBy || userId || "",
    institutionId = subjectData.institutionId || "",
    institutionName = subjectData.institutionName || ""
  } = options;

  const normalizedDocuments = SUBJECT_DOCUMENT_FIELDS.reduce((acc, field) => {
    acc[field] = normalizeDocument(subjectData[field]);
    return acc;
  }, {});

  return {
    ...subjectData,
    name: (subjectData.name || "").trim(),
    code: (subjectData.code || "").trim(),
    description: (subjectData.description || "").trim(),
    department: subjectData.department || "",
    grade:
      subjectData.grade === undefined || subjectData.grade === null
        ? ""
        : String(subjectData.grade),
    nominalHours:
      subjectData.nominalHours === undefined || subjectData.nominalHours === null
        ? ""
        : String(subjectData.nominalHours),
    phase: subjectData.phase || "",
    status: subjectData.status || "Active",
    userId,
    createdBy,
    institutionId,
    institutionName,
    poaDocument: normalizedDocuments.poaDocument,
    atpDocument: normalizedDocuments.atpDocument,
    policyDocument: normalizedDocuments.policyDocument,
    sipDocument: normalizedDocuments.sipDocument,
    capsDocument: normalizedDocuments.capsDocument
  };
};
